// extracted by mini-css-extract-plugin
module.exports = {"block":"copy-block-module--block--3rwTi","mmLogo":"copy-block-module--mm-logo--2UDSg"};